import React, { useState, useEffect, ChangeEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Autocomplete,
  InputAdornment,
  TextField,
  MaterialIcons,
} from '@iclinic/design-system';
import { searchComplaint } from '../state/search';
import { addComplaint } from '../state';
import { ComplaintSearchItem } from '../types';
import { searchSelector } from '../state/selectors';

const { SearchOutlined } = MaterialIcons;

const groupBy = (option: ComplaintSearchItem) => option.type;

const renderInput = (params: any) => {
  const { className, ...inputProps } = params.InputProps;

  return (
    <TextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...params}
      label="Adicione aqui a queixa"
      placeholder="Digite aqui"
      InputProps={{
        ...inputProps,
        endAdornment: (
          <InputAdornment position="end">
            <SearchOutlined />
          </InputAdornment>
        ),
      }}
    />
  );
};

const ComplaintInput = () => {
  const [inputValue, setInputValue] = useState('');
  const [
    selectedComplaint,
    setSelectedComplaint,
  ] = useState<ComplaintSearchItem | null>(null);
  const dispatch = useDispatch();
  const searchResult = useSelector(searchSelector);

  useEffect(() => {
    if (
      inputValue &&
      inputValue.length >= 3 &&
      selectedComplaint?.title !== inputValue
    ) {
      dispatch(searchComplaint(inputValue));
    }
  }, [inputValue, selectedComplaint, dispatch]);

  const handleChange = useCallback(
    (_: ChangeEvent<{}>, item: any) => {
      // reset values on complaint selected
      setSelectedComplaint(null);
      setInputValue('');

      if (!item) return;

      const selectedItem: ComplaintSearchItem =
        typeof item === 'string'
          ? {
              title: item,
              favorite: false,
            }
          : item;

      dispatch(addComplaint({ title: selectedItem.title }));
    },
    [dispatch],
  );

  const handleInputChange = useCallback(
    (_: React.ChangeEvent<{}>, newValue: string) => setInputValue(newValue),
    [],
  );

  return (
    <Autocomplete
      id="input-queixa"
      options={searchResult}
      getOptionLabel={(option) => option?.title || ''}
      fullWidth
      freeSolo
      inputValue={inputValue}
      groupBy={groupBy}
      onInputChange={handleInputChange}
      clearText="Limpar"
      onChange={handleChange}
      value={selectedComplaint}
      renderInput={renderInput}
    />
  );
};

export default ComplaintInput;
